<template>
<div class="d-flex flex-column">
  <div class="chat-header pa-3 d-flex" style="position:fixed;top:0;right:0;z-index:10;background:transparent;box-shadow:none;">
      <v-img :src="$theme.assets.logoContent" 
      width="12"
      contain
      class="mr-3 d-md-none"
      @click="showDrawer"/>
    <slot name="header">
      <!-- Default header content can go here -->
    </slot>
    <v-spacer></v-spacer>
    <div class="align-self-end d-flex align-center">
      <NotificationBell v-if="features.support" class="mr-1" />
      <v-menu v-if="isStaff && features.staffMenu" offset-y transition="slide-x-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="transparent"
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon class="mr-2" color="info">mdi-shield-crown-outline</v-icon>
            <span class="text-none d-none d-sm-inline-block info--text">Staff</span>
          </v-btn>
        </template>
        <v-list dense class="staff-menu">
          <div class="staff-menu__brand staff-menu__header d-flex align-center px-4 py-2">
            <img :src="duomat.assets.logoDark" alt="DuoMat" height="22">
            <span class="caption ml-2 staff-menu__version">v{{ version }}</span>
          </div>
          <template v-for="(group, gi) in staffMenu">
            <v-divider v-if="gi > 0" :key="`d-${group.label}`" />
            <v-subheader :key="`h-${group.label}`" :class="`${group.color.split(' ')[0]}--text`">
              <v-icon small class="mr-2" :color="group.color">{{ group.icon }}</v-icon>
              {{ group.label }}
            </v-subheader>
            <v-list-item
              v-for="item in group.items"
              :key="`${group.label}-${item.label}`"
              :to="item.to"
              :href="item.href"
              :target="item.href ? '_blank' : undefined"
              exact
            >
              <v-list-item-icon>
                <v-icon :color="group.color">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-menu offset-y transition="slide-x-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="transparent"
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon class="mr-2" style="color: var(--app-account-icon, #f7841d)">mdi-account-circle-outline</v-icon>
            <span class="text-none d-none d-sm-inline-block">
              {{ userName }}
            </span>
          </v-btn>
        </template>
        <v-list class="staff-menu">
          <v-list-item to="/" exact class="staff-menu__header">
            <v-list-item-icon>
              <img :src="duomat.assets.favicon" alt="" width="24" height="24">
            </v-list-item-icon>
            <v-list-item-title class="staff-menu__brand font-weight-bold">DuoMat</v-list-item-title>
          </v-list-item>
          <v-list-item to="/sync" class="d-none">
            <v-list-item-icon>
              <v-icon>mdi-sync</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Synchronisation</v-list-item-title>
          </v-list-item>
          <v-list-item to="/settings">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Réglages</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isStaff && !features.staffMenu" to="/admin">
            <v-list-item-icon>
              <v-icon color="info">mdi-database-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="info--text font-weight-bold">Admin</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isStaff && !features.staffMenu" to="/manuel/admin">
            <v-list-item-icon>
              <v-icon color="info">mdi-book-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="info--text">Manuel administrateur</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="features.support" to="/support">
            <v-list-item-icon>
              <v-badge :value="supportOpen > 0" :content="supportOpen" color="info" overlap>
                <v-icon>mdi-lifebuoy</v-icon>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-title>Aide & Support</v-list-item-title>
          </v-list-item>
          <v-list-item to="/a-propos">
            <v-list-item-icon>
              <v-icon>mdi-information-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>À propos</v-list-item-title>
          </v-list-item>
          <v-list-item to="/manuel" class="d-none">
            <v-list-item-icon>
              <v-icon>mdi-book-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Manuel utilisateur</v-list-item-title>
          </v-list-item>
          <v-list-item to="/help" class="d-none">
            <v-list-item-icon>
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Aide</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon color="error">mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="error--text">Se déconnecter</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</div>
</template>

<script>

import NotificationBell from '@/components/ui/NotificationBell.vue'
import duomat from '@/theme/themes/duomat'
import features from '@/config/features'
import { version } from '../../package.json'

const DUOMAT_FONTS_ID = 'duomat-fonts'

export default {
  name: 'HeaderLayout',
  components: { NotificationBell },
  data() {
    return { duomat, version, features }
  },
  computed: {
    isDark() { return !!this.$vuetify.theme.dark },
    isStaff() { return this.$store.getters["settings/isStaff"]},
    supportOpen() { return this.$store.state.support.counts.mine },
    staffMenu() {
      const tab = (slug, label, icon) => ({ label, icon, to: { path: '/admin', query: { tab: slug } } })
      const apiBase = process.env.VUE_APP_API_BASE_URL || ''
      return [
        {
          label: 'Comptes',
          color: 'blue',
          icon: 'mdi-account-group-outline',
          items: [
            tab('utilisateurs', 'Utilisateurs', 'mdi-account-multiple-outline'),
            tab('organisations', 'Organisations', 'mdi-domain'),
          ],
        },
        {
          label: 'LLM & Agentic',
          color: 'deep-purple',
          icon: 'mdi-robot-outline',
          items: [
            tab('moteurs', 'Moteurs', 'mdi-robot-outline'),
            tab('sessions', 'Sessions Agent', 'mdi-state-machine'),
            tab('tarifs', 'Tarifs', 'mdi-currency-usd'),
            { label: 'Évaluation comparative', icon: 'mdi-compare-horizontal', to: '/admin/test/comparative' },
          ],
        },
        {
          label: 'Setups',
          color: 'orange darken-1',
          icon: 'mdi-cog-transfer-outline',
          items: [
            tab('plans-stock', 'Plans de stock', 'mdi-warehouse'),
            tab('fichiers', 'Fichiers', 'mdi-file-multiple-outline'),
          ],
        },
        {
          label: 'Outils',
          color: 'teal',
          icon: 'mdi-tools',
          items: [
            tab('taches', 'Tâches', 'mdi-cog-sync-outline'),
            { label: 'Navigateur de conversations', icon: 'mdi-forum-outline', to: '/admin/legacy/conversations' },
            { label: 'Back-office Django', icon: 'mdi-database-cog-outline', href: apiBase.replace(/\/api\/?$/, '') + '/admin/' },
          ],
        },
        {
          label: 'Support',
          color: 'red lighten-1',
          icon: 'mdi-lifebuoy',
          items: [
            { label: 'Tickets', icon: 'mdi-ticket-outline', to: '/admin/tickets' },
          ],
        },
        {
          label: 'Documentation',
          color: 'blue-grey',
          icon: 'mdi-book-open-page-variant-outline',
          items: [
            { label: 'Manuel administrateur', icon: 'mdi-book-cog-outline', to: '/manuel/admin' },
          ],
        },
      ]
    },
    userName: {
      get() {
        return this.$store.getters["settings/userName"];
      },
      set(value) {
        this.$store.commit("settings/SET_USER_NAME", value);
      }
    },
  },
  created() {
    if (features.support) this.$store.dispatch('support/loadCounts')
    this.loadDuomatFonts()
  },
  methods: {
    /** The staff menu is always DuoMat-branded, whatever theme is active. */
    loadDuomatFonts() {
      if (document.getElementById(DUOMAT_FONTS_ID)) return
      const link = document.createElement('link')
      link.id = DUOMAT_FONTS_ID
      link.rel = 'stylesheet'
      link.href = duomat.fonts.stylesheet
      document.head.appendChild(link)
    },
    showDrawer() {
      this.$emit('drawer-show');
    },
    async logout() {
      await this.$store.dispatch("settings/logout")
      this.$store.commit("chat/RESET_STATE")
      this.$store.commit("support/RESET_STATE")
      this.$router.push('/login').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.staff-menu {
  padding-top: 0 !important;
  font-family: 'DM Sans', system-ui, sans-serif;

  .v-subheader,
  .staff-menu__brand {
    font-family: 'Manrope', system-ui, sans-serif;
  }
  .v-list-item__title {
    font-family: 'DM Sans', system-ui, sans-serif;
  }

  // Always DuoMat navy, whatever the theme or mode.
  .staff-menu__header {
    background: #1f4e7a;
    color: #ffffff !important;

    .v-list-item__title { color: #ffffff; }
    .staff-menu__version { color: #d6e8f8; }
  }
}
</style>